import { SecurityContext } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

/**
 * Endurecimento de seguranca (Angular 14 sem suporte / CVE-2026-22610).
 *
 * Use `sanitizeHtml` no lugar de `bypassSecurityTrustHtml` quando o conteudo
 * pode conter texto vindo de usuario/cliente/API (templates, mensagens,
 * observacoes). O sanitizer do Angular remove <script>, atributos on*, URLs
 * javascript: etc. Retorna string, que o `[innerHTML]` aceita (e sanitiza de
 * novo, o que e inofensivo).
 */
export function sanitizeHtml(
  sanitizer: DomSanitizer,
  html: string | null | undefined
): string {
  return sanitizer.sanitize(SecurityContext.HTML, html ?? '') ?? '';
}

/**
 * Valida a URL que sera confiada como recurso (iframe/embed). Aceita http(s),
 * blob:, data: de PDF/imagem e URLs relativas (sem esquema). Bloqueia
 * javascript:, vbscript:, data:text/html e qualquer outro esquema.
 */
export function isSafeResourceUrl(url: string | null | undefined): boolean {
  // Remove espacos/controles que os navegadores ignoram antes do esquema
  // ("java\tscript:"), para nao enganar a checagem.
  // eslint-disable-next-line no-control-regex
  const value = String(url ?? '').replace(/[\u0000-\u0020]/g, '');
  if (!value) {
    return false;
  }
  if (/^(https?:|blob:)/i.test(value)) {
    return true;
  }
  if (/^data:(application\/pdf|image\/(png|jpe?g|gif|webp));/i.test(value)) {
    return true;
  }
  if (/^data:(application\/pdf|image\/(png|jpe?g|gif|webp)),/i.test(value)) {
    return true;
  }
  return !/^[a-z][a-z0-9+.-]*:/i.test(value);
}

/**
 * Substitui `bypassSecurityTrustResourceUrl(url)` para URLs que podem vir de
 * API/usuario: so confia na URL se o esquema for seguro; senao usa about:blank.
 */
export function trustResourceUrl(
  sanitizer: DomSanitizer,
  url: string | null | undefined
): SafeResourceUrl {
  return sanitizer.bypassSecurityTrustResourceUrl(
    isSafeResourceUrl(url) ? String(url).trim() : 'about:blank'
  );
}
